/**
 * Centralized dayjs configuration with all required plugins
 * This replaces moment.js (300KB) with dayjs (2KB + plugins ~10KB)
 *
 * Usage: import dayjs from '@/lib/dayjs'
 */
import dayjs from "dayjs"
import relativeTime from "dayjs/plugin/relativeTime"
import customParseFormat from "dayjs/plugin/customParseFormat"
import isSameOrAfter from "dayjs/plugin/isSameOrAfter"
import isSameOrBefore from "dayjs/plugin/isSameOrBefore"
import timezone from "dayjs/plugin/timezone"
import utc from "dayjs/plugin/utc"
import duration from "dayjs/plugin/duration"
import isoWeek from "dayjs/plugin/isoWeek"

// Extend dayjs with plugins
dayjs.extend(relativeTime)
dayjs.extend(customParseFormat)
dayjs.extend(isSameOrAfter)
dayjs.extend(isSameOrBefore)
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(duration)
dayjs.extend(isoWeek)

export default dayjs
